import { apiFetch } from "../utils/apiFetch"

export function createDesign(data: any) {
  return apiFetch("/api/designs", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function getDesigns() {
  return apiFetch("/api/designs")
}

export function getDesignById(id: string) {
  return apiFetch(`/api/designs/${id}`)
}

export function updateDesign(id: string, data: any) {
  return apiFetch(`/api/designs/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function deleteDesign(id: string) {
  return apiFetch(`/api/designs/${id}`, { method: "DELETE" })
}
